module.exports = __webpack_public_path__ + "mg.svg?56421257c8ef399e5da94247d928097b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mg.svg
// module id = 1317
// module chunks = 27